import React from "react";
import { Skeleton } from "@envestnet/envreact-component-library";

const pageSkeleton = () => (
  <div style={{ marginTop: 100 }}>
    <Skeleton
      variant="text"
      height={30}
      width="50%"
      style={{ margin: "auto" }}
    />
    <Skeleton
      variant="text"
      height={30}
      width="60%"
      style={{ margin: "auto" }}
    />
    <Skeleton
      variant="text"
      height={30}
      width="100%"
      style={{ marginTop: 16 }}
    />
    <Skeleton variant="text" height={60} width="100%" />
    <Skeleton
      variant="text"
      height={30}
      width="100%"
      style={{ marginTop: 16 }}
    />
    <Skeleton variant="text" height={60} width="100%" />

    <Skeleton
      variant="text"
      height={60}
      width="100%"
      style={{ marginTop: 16 }}
    />
  </div>
);

export default pageSkeleton;
